import { FC } from "react";
import { Center, Spinner } from "@chakra-ui/react";

export const ProfilePageMainInfoPending: FC = () => {
  return (
    <Center flex="1">
      <Spinner />
    </Center>
  );
};
